import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { emailService } from '../services/emailService';
import { productService } from '../services/productService'; // Importer productService
import HeroCarousel from '../components/HeroCarousel';
import ReviewsCarousel from '../components/ReviewsCarousel';

const HERO_SLIDES = [
  {
    src: 'https://i.postimg.cc/RFML3r6J/image-(2).png', // "Un produit acheté = un produit offert" banner
    alt: 'Offre : Un produit acheté = un produit offert'
  },
  {
    src: 'https://i.postimg.cc/rp9S2hhB/image-(1).png', // "Octobre Rose" banner
    alt: 'Octobre Rose - El Hiba Para'
  }
];

const BRAND_LOGOS = [
  { src: 'https://i.postimg.cc/MGwFYFfc/image.png', alt: 'Vichy' },
  { src: 'https://i.postimg.cc/rp9YZN58/image-(1).png', alt: 'Dercos' },
  { src: 'https://i.postimg.cc/6Qh1bfCB/image-(2).png', alt: 'Avène' },
  { src: 'https://i.postimg.cc/9QL7x4rM/image-(3).png', alt: 'La Roche-Posay' },
  { src: 'https://i.postimg.cc/zGxgdLVD/image-(4).png', alt: 'CeraVe' },
  { src: 'https://i.postimg.cc/Kc74qKWb/isdin-logo-png-seeklogo-338247.png', alt: 'Isdin' },
  { src: 'https://i.postimg.cc/fW7k23Pw/La-Roche-Posay-Logo.png', alt: 'La Roche-Posay' },
  { src: 'https://i.postimg.cc/Dyyfxxsj/Cera-Ve-Logo-removebg-preview.png', alt: 'CeraVe' }
];

const REVIEWS = [
  { name: 'Khadija', image: 'https://i.postimg.cc/mhfZx5bp/Whats-App-Image-2026-10-01-at-5-56-29uuu-PM.jpg' },
  { name: 'Mohamed', image: 'https://i.postimg.cc/fknW4rwH/Whats-App-Image-2026-10-01-at-5-56-28-Pumu-M.jpg' },
  { name: 'Yassmine', image: 'https://i.postimg.cc/hhW4F5S2/Whats-App-Image-2026-10-01-at-5-56-29-PM.jpg' },
  { name: 'Malika', image: 'https://i.postimg.cc/grFc9TYS/Whats-App-Image-2026-10-01-at-5kk-56-28-PM.jpg' }
];

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Contact form state
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      // Utiliser productService pour récupérer les produits
      const data = await productService.getLatestProducts(8);
      
      console.log('✅ Produits chargés avec succès :', data);
      
      setProducts(data);
      setError(null);
    } catch (error) {
      console.error('❌ Erreur lors du chargement des produits :', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Handle contact form input changes
  const handleContactChange = (e) => {
    setContactForm({
      ...contactForm,
      [e.target.name]: e.target.value
    });
  };

  // Handle contact form submission
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    
    if (!contactForm.name || !contactForm.email || !contactForm.message) {
      toast.error('Veuillez remplir tous les champs obligatoires');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(contactForm.email)) {
      toast.error('Veuillez saisir une adresse e-mail valide');
      return;
    }

    setIsSubmitting(true);

    try {
      await emailService.sendContactEmail(contactForm);
      
      toast.success('Message envoyé avec succès ! Nous reviendrons vers vous bientôt.');
      
      // Reset form
      setContactForm({
        name: '',
        email: '',
        message: ''
      });
      
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message de contact :', error);
      toast.error('Échec de l\'envoi du message. Veuillez réessayer ou nous contacter directement.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'MAD'
    }).format(price);
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <HeroCarousel images={HERO_SLIDES} />
            <div className="hero-text">
             <h1>
  <img 
              src="https://i.postimg.cc/t4xTCC3x/Firefly-Remove-Background.png" 
              alt="El Hiba Para Logo" 
              style={{
                height: '50px',
                width: 'auto',
                objectFit: 'contain',
                marginRight: '8px'
              }}
            />
  Parapharmacie El Hiba Ain Aouda
</h1>
<h4>Dermocosmétique, Routine & Conseil</h4>
              <p className="hero-subtitle">
                Votre parapharmacie de la pharmacie el Hiba Ain Aouda
              </p>
              <div className="hero-actions">
                <Link to="/products" className="btn btn-primary btn-large hero-btn-buy">
                  <i className="fas fa-tag"></i>
                  Acheter maintenant
                </Link>
                <Link to="/#contact" className="btn btn-outline btn-large hero-btn-contact">
                  <i className="fas fa-phone"></i>
                  Nous contacter
                </Link>
              </div>
              <div className="hero-contact-bar">
                <a href="tel:+212708786202" className="hero-contact-item">
                  <i className="fas fa-phone"></i>
                  <span>+212 7 08 78 62 02</span>
                </a>
                <a
                  href="https://maps.app.goo.gl/dFQtFPcHiPfVVqoB6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hero-contact-item"
                >
                  <i className="fas fa-map-marker-alt"></i>
                  <span>lot 551 , quartier al wahda Ain el aouda , RabatSalé-Kénitra , maroc</span>
                </a>
                <a
                  href="https://www.instagram.com/parapharmacie.elhibaainaouda/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hero-contact-item"
                >
                  <i className="fab fa-instagram"></i>
                  <span>parapharmacie.elhibaainaouda</span>
                </a>
                <a
                  href="https://maps.app.goo.gl/dFQtFPcHiPfVVqoB6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hero-contact-item hero-contact-map"
                  title="Voir sur la carte"
                >
                  <i className="fas fa-map"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Introduction */}
      <section className="section brand-intro">
        <div className="container">
          <div className="brand-intro-content">
            <div className="brand-intro-text">
              <h2>À propos de El Hiba Para</h2>
              <p>
                Découvrez une large sélection de produits parapharmaceutiques 100% authentiques : dermo-cosmétique, soins visage et corps, cosmétiques bio et compléments alimentaires pour femme, hommes, bébé, maman et adolescents.
              </p>
              <p dir="rtl" lang="ar">
                اكتشفوا مجموعة واسعة من المنتجات شبه الصيدلانية الأصلية 100%: مستحضرات التجميل الجلدية، ومستحضرات العناية بالوجه والجسم، ومستحضرات التجميل العضوية، والمكملات الغذائية للنساء والرجال والرضع والأمهات والمراهقين.
              </p>
              <div className="brand-features">
                <div className="feature">
                  <i className="fas fa-shield-alt"></i>
                  <div>
                    <h3>Authenticité Garantie 100%</h3>
                    <p>Produits 100% authentiques et traçables.</p>
                    <p dir="rtl" lang="ar">منتجات أصلية 100% قابلة للتتبع.</p>
                  </div>
                </div>
                <div className="feature">
                  <i className="fas fa-shipping-fast"></i>
                  <div>
                    <h3>Livraison Éclair</h3>
                    <p>Livraison gratuite le jour même à Aïn El Aouda, et expédition sous 24h à 48h partout au Maroc.</p>
                    <p dir="rtl" lang="ar">توصيل مجاني في نفس اليوم داخل عين العودة، وشحن سريع لجميع أنحاء المغرب خلال 24 إلى 48 ساعة.</p>
                  </div>
                </div>
                <div className="feature">
                  <i className="fas fa-user-md"></i>
                  <div>
                    <h3>Expertise de Confiance</h3>
                    <p>Un accompagnement personnalisé par notre pharmacienne et son équipe pour des conseils 100% sur-mesure.</p>
                    <p dir="rtl" lang="ar">مرافقة شخصية من صيدلانية خبيرة وفريقها لتقديم نصائح مخصصة تناسب احتياجاتكم، بعيداً عن الإجابات الجاهزة.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="brand-intro-image">
              <img 
                src="https://i.postimg.cc/gchmZBw6/Chat-GPT-Image-30-sept-2026-16-06-58.png"
                alt="Healthcare Professional"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Latest Products */}
      <section className="section latest-products">
        <div className="container">
          <div className="section-header">
            <h2>
              <i className="fas fa-star"></i>
              Nouveaux produits
            </h2>
            <p>Découvrez nos nouveautés pour vous aider à maintenir une santé optimale</p>
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner">
                <div className="spinner"></div>
                <p className="loading-message">Chargement des nouveaux produits...</p>
              </div>
            </div>
          ) : error ? (
            <div className="error">
              <h3>❌ Erreur lors du chargement des produits</h3>
              <p>{error}</p>
              <button onClick={loadProducts} className="btn btn-primary">
                <i className="fas fa-refresh"></i>
                Réessayer
              </button>
            </div>
          ) : products.length > 0 ? (
            <>
              <div className="product-grid">
                {products.map(product => (
                  <div key={product.id} className={`product-card`}>
                    <div className="product-image-container">
                      <img 
                        src={product.imageUrl || 'https://plus.unsplash.com/premium_photo-1670537995287-6dfadc8e57df?q=80&w=435&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'} 
                        alt={product.name}
                        className="product-image"
                      />

                      <div className="product-overlay">
                        <Link 
                          to={`/products/${product.id}`} 
                          className="btn btn-primary btn-view-product"
                        >
                          <i className="fas fa-eye"></i>
                          Voir le détail
                        </Link>
                      </div>
                    </div>
                    
                    <div className="product-info">
                      <h3 className="product-name">{product.name}</h3>
                      {/* Show all categories if present */}
                      <p className="product-subtitle">
                        {Array.isArray(product.categories)
                          ? product.categories.join(', ')
                          : (product.category || '')}
                      </p>
                      <p className="product-price">
                          <span className="current-price">{formatPrice(product.price)}</span>
                        {' '}
                        <span className="old-price">
                        {formatPrice(product.price + 20)}
                        </span>
                      </p>
                      
                      <div className="product-stock">
                        <span className={`stock-badge ${product.stockQuantity > 0 ? 'in-stock' : 'out-of-stock'}`}>
                          <i className={`fas ${product.stockQuantity > 0 ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
                          {product.stockQuantity > 0 ? `En stock` : 'Rupture de stock'}
                        </span>
                      </div>
                      
                      <p className="product-description">
                        {product.description?.substring(0, 100)}...
                      </p>
                      
                      <div className="product-actions">
                        <Link 
                          to={`/products/${product.id}`} 
                          className="btn btn-primary btn-full"
                        >
                          <i className="fas fa-shopping-cart"></i>
                          Commander
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="section-actions">
                <Link to="/products" className="btn btn-primary btn-large">
                  <i className="fas fa-th-large"></i>
                  Voir tous les produits
                </Link>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <h3>Aucun produit disponible</h3>
              <p>Aucun produit trouvé pour le moment.</p>
            </div>
          )}
        </div>
      </section>

      {/* Reviews Section */}
      <section className="section reviews">
        <div className="container">
          <div className="section-header">
            <h2>
              <i className="fas fa-comments"></i>
              Avis clients
            </h2>
            <p>Ce que disent nos clients sur leur expérience El Hiba Para</p>
          </div>

          <ReviewsCarousel reviews={REVIEWS} />
        </div>
      </section>

      {/* Official Brands Marquee */}
      <section className="section brands-marquee">
        <div className="container">
          <div className="section-header">
            <h2>Nos Boutiques Officielles</h2>
          </div>
        </div>
        <div className="brands-track-wrapper">
          <div className="brands-track">
            {[...Array(6)].map((_, loopIndex) => (
              <React.Fragment key={loopIndex}>
                {BRAND_LOGOS.map((brand, brandIndex) => (
                  <div className="brand-card" key={`${loopIndex}-${brandIndex}`}>
                    <img className="brand-logo-img" src={brand.src} alt={brand.alt} />
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section - UPDATED WITH FUNCTIONAL FORM */}
      <section className="section contact" id="contact">
        <div className="container">
          <div className="section-header">
            <h2>
              <i className="fas fa-envelope"></i>
              Nous contacter
            </h2>
            <p>Vous avez des questions ? Nous sommes là pour vous accompagner dans votre parcours bien-être</p>
          </div>

          <div className="contact-content">
            <div className="contact-info">
              <h3>Contactez-nous</h3>
              <div className="contact-methods">
                <div className="contact-method">
                  <i className="fas fa-map-marker-alt"></i>
                  <div>
                    <strong>Adresse</strong>
                    <p>lot 551 , quartier al wahda Ain el aouda , RabatSalé-Kénitra , maroc</p>
                  </div>
                </div>
                <div className="contact-method">
                  <i className="fas fa-phone"></i>
                  <div>
                    <strong>Téléphone</strong>
                    <p>0708786202</p>
                  </div>
                </div>
                <div className="contact-method">
                  <i className="fas fa-envelope"></i>
                  <div>
                    <strong>Email</strong>
                    <p>pharmacie.elhiba@gmail.com</p>
                  </div>
                </div>
                <div className="contact-method">
                  <i className="fas fa-clock"></i>
                  <div>
                    <strong>Horaires</strong>
                    <p>Lundi-Dimanche : 24h/24</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form">
              <form onSubmit={handleContactSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">
                      <i className="fas fa-user"></i>
                      Nom *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={contactForm.name}
                      onChange={handleContactChange}
                      required
                      placeholder="Votre nom complet"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">
                      <i className="fas fa-envelope"></i>
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={contactForm.email}
                      onChange={handleContactChange}
                      required
                      placeholder="votre.email@exemple.com"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">
                    <i className="fas fa-comment"></i>
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={contactForm.message}
                    onChange={handleContactChange}
                    required
                    rows="5"
                    placeholder="Dites-nous en plus sur votre demande..."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="btn btn-primary btn-large"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <i className="fas fa-spinner fa-spin"></i>
                      Envoi du message...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i>
                      Envoyer le message
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;